import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M3.834 12.374L2.12 10.66l-.285 2 2-.286zM2.713 9.143L5.35 11.78l7.65-7.65-2.638-2.639-7.65 7.65zM11.419.437l2.638 2.638c.582.583.582 1.528 0 2.11l-8.09 8.09c-.229.23-.525.377-.845.423l-4.062.58c-.408.058-.786-.225-.844-.633-.01-.07-.01-.141 0-.211l.58-4.063c.046-.32.194-.615.422-.844l8.09-8.09c.583-.583 1.528-.583 2.11 0z"
      transform="scale(1.4 1.4) translate(1.1 1)"
      fill={fill}
    />
  </g>
);

export default Icon;
